<template>
  <div class="kpi-modal">
    <div class="modal fade" data-bs-backdrop="static" id="kpiDeleteModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div v-if="elementType" class="modal-content bg-primary">
          <div class="modal-header">
            <div class="h5 modal-title text-light">
              <span v-if="elementType === 'kpi'"> {{ $t("views.kpi.detail.headingDeleteKPI") }} </span>
              <span v-if="elementType === 'formula'"> {{ $t("views.kpi.detail.headingDeleteFormula") }} </span>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body bg-light">
            <div class="text-center my-3">
              <p v-if="elementType === 'kpi'" class="fw-bold">{{ selectedKPI.name }}</p>
              <span v-if="elementType === 'kpi'"> {{ $t("views.kpi.detail.confirmDeleteKPI") }} </span>
              <span v-if="elementType === 'formula'"> {{ $t("views.kpi.detail.confirmDeleteFormula") }} </span>
            </div>
          </div>
          <div class="modal-footer bg-light">
            <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
            <button @click="deleteElement()" type="button" class="btn btn-sm btn-danger" data-bs-dismiss="modal">{{ $t("general.delete") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KPIDeleteModal',
  data () {
    return {
    }
  },
  computed: {
    selectedKPI () {
      return this.$store.state.selectedKPI
    },
    elementId () {
      return this.$parent.kpiModalElementId
    },
    elementType () {
      return this.$parent.kpiModalElementType
    }
  },
  methods: {
    async deleteElement () {
      try {
        this.$store.commit('SET_LOADING_STATUS', true)
        if (this.elementType === 'kpi' && !this.selectedKPI.hasNodes) {
          await this.$store.dispatch('deleteKPI', this.selectedKPI.id)
        } else {
          await this.$store.dispatch('deleteKPIElement', { kpiId: this.selectedKPI.id, elementType: (this.elementType + 's'), elementId: this.elementId })
        }
      } finally {
        this.$store.commit('SET_LOADING_STATUS', false)
      }
    }
  }
}
</script>
